// Front Desk notice (ADR-0047): an organization without a company profile (existing workspaces) or
// whose registration needs corrections is invited to complete it. Never blocks any work.
import { Link } from "@tanstack/react-router";
import { Button } from "@/ui/button";
import { Callout } from "@/ui/layout";
import { useCompany } from "./queries";

export function CompanyNotice({ orgId }: { orgId: string }) {
  const { data } = useCompany(orgId);
  if (!data?.canManage) return null;
  const status = data.profile?.status;
  if (status && status !== "REJECTED") return null;
  return (
    <Callout
      title={
        status === "REJECTED" ? "Tu registro empresarial requiere correcciones" : "Completa el perfil de tu empresa"
      }
      tone="warning"
    >
      <span>
        {status === "REJECTED"
          ? (data.profile?.statusReason ?? "Media Interactiva pidió correcciones.")
          : "Tu espacio de trabajo sigue funcionando igual. El perfil es necesario para trabajar con órdenes de compra."}{" "}
      </span>
      <Button asChild variant="link" className="h-auto p-0">
        <Link to={`/o/${orgId}/settings`}>Ir a Configuración</Link>
      </Button>
    </Callout>
  );
}
